import { render, staticRenderFns } from "./FaqHome.vue?vue&type=template&id=f5d5fb48&scoped=true"
import script from "./FaqHome.vue?vue&type=script&lang=js"
export * from "./FaqHome.vue?vue&type=script&lang=js"
import style0 from "./FaqHome.vue?vue&type=style&index=0&id=f5d5fb48&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d5fb48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5d5fb48')) {
      api.createRecord('f5d5fb48', component.options)
    } else {
      api.reload('f5d5fb48', component.options)
    }
    module.hot.accept("./FaqHome.vue?vue&type=template&id=f5d5fb48&scoped=true", function () {
      api.rerender('f5d5fb48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/faq/FaqHome.vue"
export default component.exports